import './ticket_details_tab_view.js.coffee'
Namespace 'Customer.Tabs'

class Customer.Tabs.NewTicketTabView extends Customer.Tabs.TicketDetailsTabView
  events: ->
    _.extend({}, Customer.Tabs.TicketDetailsTabView.prototype.events,
      'click .fa-close': '_confirmCloseTab'
    )

  listenToTriggers: ->
    super()
    @listenTo(@tabbableView, 'press:cancel', @_confirmCloseTab)

  _confirmCloseTab: ->
    swal
      title: I18n.t('customer.dashboard.new_case.modal.cancel_button.title')
      text: I18n.t('customer.dashboard.new_case.modal.cancel_button.text')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-success'
      cancelButtonText: I18n.t('customer.dashboard.new_case.modal.cancel_button.cancel')
      confirmButtonText: I18n.t('customer.dashboard.new_case.modal.cancel_button.confirm')
      closeOnConfirm: true
      => @onClickClose()
